import React from 'react';
import Slider from 'react-slick';
import { Image } from 'react-bootstrap';
import { BsStarFill } from 'react-icons/bs';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ReviewComponent.css';
import '../App.css'

import Client1 from "../assets/imgs/client-1-img.png";
import Client2 from "../assets/imgs/client-2-img.png";
import Client3 from "../assets/imgs/client-3-img.png";

    const ReviewComponent = () => {
        const reviews = [
            {
                clientName: "Alice Johnson",
                clientImage: Client1,
                clientReview: "This service was fantastic! Highly recommend.",
                rating: 5,
            },
            {
                clientName: "Sarah Lee",
                clientImage: Client2,
                clientReview: "Professional, courteous, and efficient. A great experience overall!",
                rating: 5,
            },
            {
                clientName: "David Smith",
                clientImage: Client3,
                clientReview: "Extremely satisfied with the quality and speed of the service.",
                rating: 5,
            },
        ];

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        arrows: false
                    }
                }
            ]
        };

        return (
            <div className="review-section-margn">
                <div className="review-section">
                    <Slider {...settings}>
                        {reviews.map((review, index) => (
                            <div key={index} className="review-card">
                                <Image src={review.clientImage} roundedCircle className="client-image" />
                                <h3 className="client-name">{review.clientName}</h3>
                                <p className="client-review">{review.clientReview}</p>
                                <div className="stars">
                                    {[...Array(5)].map((_, i) => (
                                        <BsStarFill key={i} className={i < review.rating ? 'star-filled' : 'star-unfilled'} />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        );
    };

    export default ReviewComponent;
